import { CommonModule, KeyValue } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BillPayServicesService } from '../helper/bill-pay-services.service';
import { ValidatePipe } from '../helper/validate.pipe';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,

} from '@angular/forms';
import { ToasterService } from '@core/services/toaster.service';
import { PaymentSuccessComponent } from '../payment-success/payment-success.component';
import { ConfirmationModalConfig, ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import { result } from 'lodash';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';


@Component({
  selector: 'app-fetch-bill-validate',
  standalone: true,
  imports: [
    CommonModule,
    ValidatePipe,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './fetch-bill-validate.component.html',
  styleUrl: './fetch-bill-validate.component.scss',
})
export class FetchBillValidateComponent {
  _BillPayservice: BillPayServicesService = inject(BillPayServicesService);
  _ConfirmationModalService: ConfirmationModalService = inject(
    ConfirmationModalService
  );
  billerdetails: { [key: string]: any };
  billerInfo: any;
  myControl = new FormControl('');
  paybleAmount: any;
  detailsList: any;
  // amount : any ;
  // category_code :any;
  // billerResponse:any ;
  biller_params: any = {};
  validateUser: any;
  max: any;
  errorMessage: string | null = null;
  constructor(
    private fb: FormBuilder,
    private route: Router,
    private toaster: ToasterService,
    public dialogRef: ConfirmationModalOverlayRef,
  ) { }
  ngOnInit() {
    this.initialData();
  }
  initialData() {
    this._BillPayservice.getValidateInitialData().subscribe((res: any) => {
      // console.log(res.data , 'response..')
      if (res) {
        this.billerdetails = res?.result;
        // console.log(res?.result, 'response.....')

        // console.log(this.billerdetails , 'billerdetails....');
        this.billerInfo = res;
        this.paybleAmount = res?.result?.billAmount;
        this.max = res?.result?.billAmount;
        this.validateUser = res?.result;
        // this.toaster.showSuccess(res?.message , '');
      } else {
        // this.toaster.showError(res?.message , '')
        this.route.navigate(['/bbps']);
      }
      // this.myControl.valueChanges.subscribe((e: any) => { });
    });

    this._BillPayservice.getBillParams().subscribe((res: any) => {
      if (res) {
        this.biller_params = res;
        // this.toaster.showSuccess(res?.message , '');
      } else {
        // this.toaster.showError(res?.message , 'error');
      }
    });
    this._BillPayservice.getFetchBillData().subscribe((res: any) => {
      if (res) {
        // this.dataList = res?.bill_params;
        this.detailsList = res;
        // this.toaster.showSuccess(res?.message , 'success')
      }
      else {
        // this.toaster.showError(res?.message , 'error')
      }
    });


  }

  validateAmount(event: any) {
    // console.log(this.billerInfo?.billAmount , this.amount , 'test data..')
    this.errorMessage = '';
    const inputElement = event.target as HTMLInputElement;
    const inputValue = Number(inputElement.value);
    // this.myControl.addValidators(Validators.required);
    // console.log(inputValue, 'inputValue')

    this.myControl.updateValueAndValidity();

    if (!inputElement.value.trim()) {
      event.preventDefault();
      return;
    }

    if (this.billerInfo?.billpay_type == 'EXACT_ABOVE') {
      if (inputValue < this.billerInfo?.billAmount) {
        // this.toaster.showError('The entered value cannot be less than the bill amount.' , 'error')
        this.errorMessage =
          'The entered value cannot be less than the bill amount.';
        event.preventDefault();
        return;
      }
    }
    if (this.billerInfo.billpay_type == 'EXACT_BELOW') {
      if (inputValue == 0 || inputValue > this.billerInfo?.billAmount) {
        event.preventDefault();
        // this.toaster.showError('The entered value cannot be greater than the bill amount.' , 'error')
        this.errorMessage =
          'The entered value cannot be greater than the bill amount.';

        return;
      }
    }
  }
  getData(payLoad: any) {
    this._BillPayservice
      .getInitiateBillPayment(payLoad)
      .subscribe((res: any) => {
        if (res) {
          this.validateUser = res?.result;
          this.toaster.showSuccess(res?.message, '');
          this.billerdetails = Object.assign(
            res?.result?.billerResponse,
            res?.result?.charges
          );
        } else {
          this.toaster.showError(res?.message, 'error');
        }
      });
  }

  // fetchData() {
  //   let payLoad = {};
  //   if (this.billerInfo.billpay_type == 'EXACT') {
  //     payLoad = {
  //       amount: this.billerInfo?.billAmount,
  //       request_type: 'CONFIRM',
  //       requestId: this.billerInfo?.ref_id,
  //       billerId: this.billerInfo?.biller_id,
  //       inputParams: this.biller_params,
  //       billerResponse: {
  //         billAmount: this.billerInfo?.billAmount,
  //         billDate: this.billerInfo?.billDate,
  //         billNumber: this.billerInfo?.billNumber,
  //         billPeriod: this.billerInfo?.billPeriod,
  //         customerName: this.billerInfo?.customerName,
  //         dueDate: this.billerInfo?.dueDate,
  //       },
  //     };
  //     this.getData(payLoad);
  //   } else {
  //     payLoad = {
  //       amount: this.myControl.value,
  //       request_type: 'CONFIRM',
  //       requestId: this.billerInfo?.ref_id,
  //       billerId: this.billerInfo?.biller_id,
  //       inputParams: this.biller_params,
  //       billerResponse: {
  //         billAmount: this.billerInfo?.billAmount,
  //         billDate: this.billerInfo?.billDate,
  //         billNumber: this.billerInfo?.billNumber,
  //         billPeriod: this.billerInfo?.billPeriod,
  //         customerName: this.billerInfo?.customerName,
  //         dueDate: this.billerInfo?.dueDate,
  //       },
  //     };
  //     this.getData(payLoad);
  //   }
  // }

  submit() {
    let payLoad = {};
    payLoad = {
      amount: this.billerInfo?.result?.bill_amount.split(' ',2)[1],
      request_type: 'TRANSACT',
      requestId: this.billerInfo?.result?.ref_id,
      billerId: this.billerInfo?.result?.biller_id,
      inputParams: this.biller_params,
      billerResponse : this.billerInfo?.data?.billerResponse,
      additionalInfo : this.billerInfo?.data?.additionalInfo,
      custConvFee : this.billerInfo?.result?.customer_convenience_fee
      // billerResponse: {
      //   billAmount: this.billerInfo?.bill_amount,
      //   billDate: this.billerInfo?.bill_date,
      //   billNumber: this.billerInfo?.bill_number,
      //   billPeriod: this.billerInfo?.bill_period,
      //   customerName: this.billerInfo?.customer_name,
      //   dueDate: this.billerInfo?.due_date,
      // },
    };
// console.log(payLoad, ' palode')
    this._BillPayservice
      .getInitiateBillPayment(payLoad)
      .subscribe((res: any) => {
        if (res?.response_code == '1') {

          this._BillPayservice._ReceiptData.next(res);
          this.close();
          this.route.navigate(['/bbps/payment'])
          // this._ConfirmationModalService.open(PaymentSuccessComponent);
        } else {
          this.close();
          const customConfig: ConfirmationModalConfig = {
            data: {
              icon: 'error',
              msg: res?.message,
              // btnConfirm: 'Okay',
              btnClose: 'Okay',
              showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false
            },
          };
          this._ConfirmationModalService.init(ConfirmationComponent, customConfig).subscribe((events: any) => {
            events.initRef.close();
          });
        }
      });
  }
  close() {
    // this._ConfirmationModalService.dialogRef.close();
    this.dialogRef.close();
  }
  ngOnDestroy() {
    this.close();
  }
  back() {
    this.initialData();
  }

  originalOrder = (a: KeyValue<string,string>, b: KeyValue<string,string>): number => {
    return 0;
  }
  
}
